window.__assetPrefix__ = 'https://d16jvlwtn9ip36.cloudfront.net/time-and-attendance';